import axios from "axios";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import VideoModal from "./VideoModal.js";

function WhoAreWe() {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [aboutSection, setAboutSection] = useState(null);
  const [stats, setStats] = useState([]);

  useEffect(() => {
    // Fetch About Section
    const fetchAboutSection = async () => {
      try {
        /* const res = await axiosInstance.get('/public/about/section');
        const data = res;
        console.log('About Section Data:', data);
        if (data.data.success && data.data.data) {
          // If data.data is array, take first, else take as is
          const section = Array.isArray(data.data.data) ? data.data.data[0] : data.data.data;
          setAboutSection(section);
        } */
        const response = await axios.get(`${process.env.REACT_APP_LOGIN_API_BASEURL}/json-page/name/about`);
        //console.log("API Response:", response.data); // Log response to debug
        const events = JSON.parse(response.data);
        console.log("about Events------:", events);
        setAboutSection(events.aboutSection);
        setStats(events.stats || []);
      } catch (error) {
        console.error('Error fetching about section:', error);
      }
    };

    // Fetch Stats
    /*   const fetchStats = async () => {
        try {
          const res = await axiosInstance.get('/public/about/stats');
          const data =res;
          if (data.data.success && Array.isArray(data.data.data)) {
            setStats(data.data.data);
          }
        } catch (error) {
          console.error('Error fetching stats:', error);
        }
      }; */

    fetchAboutSection();
    //fetchStats();
  }, []);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <div className="mx-auto px-4 py-12 max-w-5xl">
      {/* About Section */}
      <div className="mb-16 text-start">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6">
          {t(aboutSection?.title || "")}
        </h2>
        <div className="flex flex-col lg:flex-row gap-8 !text-left">
          <div className="lg:w-3/4">
            <p className="text-xl font-bold !text-gray-800 mb-4">
              {t(aboutSection?.mainDescription || "")}
            </p>
            <p className="!text-gray-600 leading-relaxed !text-justify !text-sm">
              {t(aboutSection?.detailedDescription || "")}
            </p>
          </div>
          {/* <div className="lg:w-3/4">
            {aboutSection?.videoThumbnail ? (
              <div
                className="relative cursor-pointer rounded-lg overflow-hidden"
                onClick={openModal}
              >
                <img
                  src={aboutSection.videoThumbnail}
                  alt="Video Thumbnail"
                  className="w-full h-auto"
                />
                <div className="!absolute inset-0 top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] flex items-center justify-center">
                  <div className="bg-white bg-opacity-80 rounded-full p-4">
                    <div className="w-12 h-12 flex items-center justify-center bg-blue-500 text-white rounded-full">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"
                        />
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <img
                src="/placeholder.svg"
                alt="No video thumbnail"
                className="w-full h-auto"
              />
            )}
          </div> */}
        </div>
      </div>

      {/* Stats Section */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 flex justify-center">
        {stats.map((stat, index) => (
          <div
            key={index}
            className="border rounded-lg p-8 text-center shadow-md transition-transform hover:scale-105"
            style={{
              backgroundColor: stat.backgroundColor || '#fff',
              borderColor: stat.borderColor || '#000',
              borderStyle: 'solid',
              borderWidth: '1px',
            }}
          >
            <h3 className="text-4xl font-bold text-gray-800 mb-2">
              {t(stat.number)}
            </h3>
            <p className="!text-gray-800">{t(stat.label)}</p>
          </div>
        ))}
      </div>

      {/* Video Modal */}
      {isModalOpen && (
        <VideoModal
          videoUrl={aboutSection?.videoUrl}
          onClose={closeModal}
        />
      )}
    </div>
  );
}

export default WhoAreWe;
